<div class="h-100 w-100 d-flex flex-column">
  <div *ngIf="(proposalTile$ |async)?.proposalName" class="proposal-name small-info-container">
    #{{(proposalTile$ |async)?.id.slice(0, 8)}} - {{(proposalTile$ |async)?.proposalName}}
  </div>
  <div *ngIf="!(proposalTile$ |async)?.proposalName"
       class="d-flex proposal-name small-info-container">
    <div class="">{{'offer.createOffer.proposalNumber' |translate}}</div>
    <div style="padding-left: 5px;">{{(proposal$|async)?.proposalNumber ?? '-'}}</div>
  </div>
  <ng-scrollbar visibility="hover" class="flex-shrink-1">
    <div class="left-inner-section">
      <div class="small-info-container">
        <div class="small-label">
          {{'offer.sum'|translate}}
        </div>
        <div class="value-text">
          {{(proposalTile$|async)?.insuredAmount | numberFormat | async}} {{(proposalTile$|async)?.insuredSumType === 'VALUES_1914' ? '' : currencySymbol((proposalTile$|async)?.insuredAmountCurrency)}}
        </div>
      </div>
      <div class="small-info-container">
        <div class="small-label">
          {{'offer.coverage' |translate}}
        </div>
        <div class="value-text"
             [style.color]="coverageColor((proposalTile$|async)?.coverage)">{{(proposalTile$|async)?.coverage | percent}}</div>
      </div>
      <div class="small-info-container">
        <div class="small-label">
          {{'offer.creationDate' |translate}}
        </div>
        <div class="value-text">
          {{(proposalTile$|async)?.creationDate| date : ('dateFormat' | translate)}}
        </div>
      </div>
      <div class="small-info-container">
        <div class="small-label">
          {{'offer.lineOfBusiness' |translate}}
        </div>
        <div>
          <span
            class="value-text">{{(proposalTile$|async)?.lineOfBusiness?.name}}
            <ng-container *ngIf="(proposalTile$|async)?.lineOfBusinessSubcategory">
              - {{(proposalTile$|async)?.lineOfBusinessSubcategory}}</ng-container>
          </span>
        </div>
      </div>
      <div class="d-flex all-cursor-pointer small-info-container"
           (click)="navigateToUserProfile()">

        <img class="custom-profile-picture me-2 rounded-circle"
             [src]="(userService.getProfilePicture((proposal$|async)?.creator?.id) |async) ?? 'assets/img/profile/default-profile-icon.png'"
             alt="private"/>

        <div class="d-flex flex-column justify-content-center">
          <span
            class="light-text small-text creator-label">{{(proposal$|async)?.creator?.firstName}} {{(proposal$|async)?.creator?.lastName}}</span>
          <a [routerLink]="'/'+ Route.COMPANY_PROFILE+'/'+ (proposal$|async)?.creator?.company.companyId"
             class="dark-text small-text company-label">{{(proposal$|async)?.creator?.company.name}}</a>
        </div>
      </div>

      <hr class="line">

      <app-proposal-details-expandable createOfferStyle="true"
                                       [isExternalCoverage]="isExternalCoverage"
                                       [(allDetailsOpen)]="allDetailsOpen"></app-proposal-details-expandable>

    </div>
  </ng-scrollbar>
</div>
